import './assets/tailwind.css'
import { useEffect } from 'react';
import {lazy, Suspense} from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from "framer-motion";
import { ProductProvider } from './context/ProductContext';

import Layout from './components/Layout';
const Error404 = lazy( () => import('./pages/Error404'));
const Loading = lazy( () => import('./components/Loading'));
// const About = lazy( () => import('./pages/About'));
const Home = lazy( () => import('./pages/Home'));
const AboutUs = lazy( () => import('./pages/AboutUs'));
const Certifications = lazy( () => import('./pages/Certifications'));
const Contact = lazy( () => import('./pages/Contact'));

const ProductList = lazy( () => import('./pages/ProductList'));
const Product = lazy( () => import('./pages/Product'));

const Products = lazy( () => import('./pages/Products'));

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page when the route changes
  }, [location.pathname]);

  return null;
};


function App() {

  return (
    <ProductProvider>
      <BrowserRouter>
      <ScrollToTop/>
        <AnimatePresence>
          <Suspense fallback={<Loading/>}>
            <Routes>
              <Route path='/' element={<Layout/>}>
                <Route index element={<Home/>}/>
                <Route path='/about' element={<AboutUs/>}/>
                <Route path='/certificates' element={<Certifications/>}/>
                <Route path='/contact' element={<Contact/>}/>
                <Route path='/product_list' element={<ProductList/>}/>
                <Route path='/product_list/:category' element={<ProductList/>}/>
                {/* <Route path='/products/pipes' element={<Pipes/>}/> */}
                <Route path='/product_list/:category/:productId' element={<Product/>}/>
                <Route path='/products/:type' element={<Products/>}/>
                <Route path="404" element={ <Error404/>} />
              </Route>
              <Route path="*" element={ <Navigate to="/404" replace />} />
            </Routes>
          </Suspense>
        </AnimatePresence>
      </BrowserRouter>
    </ProductProvider>
  );
}

export default App;